import React, { Component } from 'react';
import _ from 'lodash';

import ReactDOM from 'react-dom';

import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";

momentDurationFormatSetup(moment);

import style from './style.scss';

import utils from 'Utils/index.js';

const alert_sound = new Audio('/build/audio/alert.mp3');

window.alert_sound = alert_sound;

const calls_hash = {};

export default ({value_start, value_end, onChange, app_data, is_text, class_name}) => {

  const time_arr = [];
  const start_moment = moment('09:00', utils.TIME_FORMAT);

  time_arr.push('00:00');
  for(let i = 0; i < 15; i++) {
    time_arr.push(
      start_moment
        .clone()
        .add(i, 'hours')
        .format(utils.TIME_FORMAT)
    );
  }


  return <div className={class_name}>
    <div className="label">Время</div>

    <div className="delivery_time_select delivery__times">

      {/*TIME_START*/}
      {is_text && `${value_start} - `}

      {!is_text && <select value={value_start} onChange={(e) => {
        onChange({
          time_start: e.target.value
        })
      }}>


        {time_arr.map(time => {

          return <option key={time} value={time}>{time}</option>

        })}

      </select>}


      {/*TIME_END*/}
      {is_text && value_end}

      {!is_text && <select value={value_end} onChange={(e) => {
        onChange({
          time_end: e.target.value
        })
      }}>


        {time_arr.map(time => {

          return <option key={time} value={time}>{time}</option>

        })}

      </select>}


    </div>

  </div>;

};

